// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cVh7","input":"styles_input__Rbdsf"};